import { SESSION_SALT_NAME, SESSION_TOKEN_NAME, OTP_SESSION_IS_ACTIVE } from '../constants/session'
import { ftGetLocalStorage, ftRemoveLocalStorage } from './common'
import { getAxios } from './projectAxios'

export const webProjectSmartvLogout = async (url) => {
  try {
    const axios = getAxios()
    await axios.post('/webprojects/smart-v/logout')

    ftRemoveLocalStorage(SESSION_TOKEN_NAME)
    ftRemoveLocalStorage(SESSION_SALT_NAME)
    ftRemoveLocalStorage(OTP_SESSION_IS_ACTIVE)

    /**
     * Recreate SF Platform Events socket connection without OTP session cookies
     */
    if (typeof window?.__FT_PROJECT__API__?.reconnectSocket === 'function') {
      window.__FT_PROJECT__API__.reconnectSocket()
    }
  } catch (error) {}
}

export const webProjectSSOLogout = async () => {
  const axios = getAxios()
  const { data } = await axios.post('/webprojects/sso/logout')
  if (data.status) {
    ftRemoveLocalStorage(SESSION_TOKEN_NAME)
    ftRemoveLocalStorage(SESSION_SALT_NAME)
    var iframe = document.createElement('iframe')
    iframe.width = 0
    iframe.height = 0
    iframe.style = 'border: 0px; position: absolute;'
    iframe.src = data.url

    var callback = function () {
      if (data.callbackURL) {
        location.href = data.callbackURL
      } else {
        location.reload()
      }
    }

    if (iframe.attachEvent) {
      iframe.attachEvent('onload', function () {
        callback()
      })
    } else {
      iframe.onload = function () {
        callback()
      }
    }
    document.body.appendChild(iframe)
  }
}

export const hasWebProjectUserSession = () => {
  return (
    (!!ftGetLocalStorage(SESSION_TOKEN_NAME) && !!ftGetLocalStorage(SESSION_SALT_NAME)) ||
    !!ftGetLocalStorage(OTP_SESSION_IS_ACTIVE)
  )
}
